module.exports = __webpack_public_path__ + "img/ball_9.1f53e886.png";